export default {
	name: 'caside',
	props: {
		active: {
			type: String,
			default: '1'
		}
	},
}


// WEBPACK FOOTER //
// ./src/components/aside/index.js